import { render } from "./ReviewCard.vue?vue&type=template&id=9c45b740&scoped=true"
import script from "./ReviewCard.vue?vue&type=script&lang=js"
export * from "./ReviewCard.vue?vue&type=script&lang=js"

import "./ReviewCard.vue?vue&type=style&index=0&id=9c45b740&scoped=true&lang=scss"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c45b740"]])

export default __exports__